import { Grid } from "@mui/material";
import React from "react";
import WithdrawForm2 from "./withdrawForm2";
import Image from "../../images/withdraw.png";
import Image2 from "../../images/withdraw1.png";
import Box from "@mui/material/Box";
export default function Withdraw() {
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          lg={6}
          xl={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundSize: "100% auto!important",
            background: `url(${Image2}) no-repeat center center`,
            backdropFilter: "blur(60px)!important",
            maxHeight: "100vh",
            display: { xs: "none", lg: "flex" },
          }}
        >
          <Box component="img" sx={{ maxHeight: "50%" }} src={Image} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          lg={6}
          xl={6}
          sx={{ display: "flex", alignItems: "center!important" }}
        >
          <WithdrawForm2 />
        </Grid>
      </Grid>
    </>
  );
}
